import React from 'react';
import { connect, useSelector } from 'react-redux';
import { useProveedor } from '@infotrack/presentacion-componentes/proveedorEstado';
import notificacionGlobal from '@infotrack/presentacion-componentes/notificacionGlobal';
import { IEstadoGlobal } from 'Infotrack@Reductores/interfacesReductores';
import EntidadesFiltroInvetarioCM from '../controladorModelo/entidadesFiltroInvenitarioCM';
import {IFormularioConsultaInventarioCVProps} from '../interfaces';
import { acciones, IEstadoConsultaInventario } from '../reductorConsultaInventario';
import FormularioConsultaInventarioVista from '../vista/formularioConsultaInventarioVista';
import IBodega from 'Infotrack@Modelos/smartStock/bodegas/entidades/bodega';
import IBodegaDivisiones from 'Infotrack@Modelos/smartStock/bodegasDivisiones/entidades/bodegasDivisiones';
import IClasificaciones from 'Infotrack@Modelos/smartStock/clasificaciones/entidades/clasificaciones';
import IFamilias from 'Infotrack@Modelos/smartStock/familias/entidades/familias';
import { IInputsConsultaInventario } from 'Infotrack@Modulos/inventario/historicoInventario/interfaces';


const entidadesFiltroInvetarioCM = new EntidadesFiltroInvetarioCM();

const FormularioConsultaInventarioCV: React.FunctionComponent<IFormularioConsultaInventarioCVProps> = ({
    IdEmpresa,
}) => {
    const [bodegas, setBodegas] = React.useState<IBodega[]>([]);
    const [bodegaSelected, setBodegaSelected] = React.useState<IBodega | null>(null);
    const [familias, setFamilia] = React.useState<IFamilias[]>([]);
    const [clasificaciones, setClasificaciones] = React.useState<IClasificaciones[]>([]);
    const [divisiones, setDivisiones] = React.useState<IBodegaDivisiones[]>([]);
    const [{ estadoFormularioConsulta,filtros }, dispatch] = useProveedor<IEstadoConsultaInventario>();
    const idUsuario = useSelector((e: IEstadoGlobal) => e.estadoAutenticacion.usuarioInformacion!.IdUsuario);
    const  usuario = useSelector((e: IEstadoGlobal) => e.estadoAutenticacion.usuarioInformacion);
    



    React.useEffect(() => {
        setBodegaSelected(null);
    }, [estadoFormularioConsulta]);
    React.useEffect(() => {
        cargarEntidadesFiltros();
    }, []);

    React.useEffect(() => {
        if (filtros.BodegaId) cargarDivisionesporBodegaId();
        else setDivisiones([])
    }, [filtros.BodegaId]);

    const alCambiarfiltros = (event: React.ChangeEvent<HTMLInputElement | HTMLSelectElement | HTMLTextAreaElement>) => {
        
        
        
        
        const { name, value, type } = event.target;
        if (type === 'checkbox') {
          const checkbox = event.currentTarget as HTMLInputElement;
          dispatch({ type: acciones.MODIFICAR_FILTROS_CONSULTA, payload: { llave: name, valor: checkbox.checked } });
        } else {
          dispatch({ type: acciones.MODIFICAR_FILTROS_CONSULTA, payload: { llave: name, valor: value } });
        }
      };
      ;
    

      const alAbrirDialogo = () => {
        const clavesValidas: Array<keyof IInputsConsultaInventario> = [
            'CodigoBarras',
            'DescripcionItem',
            'Serial',
            'Lote',
            'FamiliaId',
            'ClasificacionId',
            'BodegaDecripcion',
            'BodegaId',
            'DivisionId',
            'FechaInicial',
            'FechaFinal',
            'CodigoEmpresa',
        ];
        
        const tieneFiltros = clavesValidas.some(key => {
            const valor = filtros[key as keyof IInputsConsultaInventario];
            return key !== "IdEmpresa" && 
                   valor !== null && 
                   valor !== undefined && 
                   valor !== "";
        });
    
        if (!tieneFiltros && !filtros.Bloqueado) {
            notificacionGlobal(
              'inventario.filtroObligatorio',
                 6000,
                'warning',true
            );
            return;
        }
        dispatch({ type: acciones.CAMBIAR_ESTADO_FORMULARIO });
    };

    const alLimpiarFiltros = () => {
       setBodegaSelected(null);
        dispatch({ type: acciones.LIMPIAR_FILTROS });
    };

    const cargarEntidadesFiltros = () => {
        entidadesFiltroInvetarioCM
            .consultaEntidadesFiltro(IdEmpresa, usuario!.NombrePerfil!!=="Administrador"? idUsuario:"")
            .then(
                ({ bodegas: bodegasCargadas, familias: familiaCargada, clasificaciones: clasificacionesCargadas }) => {
                    setBodegas(bodegasCargadas);
                    setFamilia(familiaCargada);
                    setClasificaciones(clasificacionesCargadas);
                }
            );
    };

    const cargarDivisionesporBodegaId = async () => {
        setDivisiones(
            await entidadesFiltroInvetarioCM.cosultaDivisionesPorBodegaId(Number(filtros.BodegaId), IdEmpresa)
        );
    };
    const alCambiarValorAutocomplete = (nuevoValor: IBodega, nombreValor: string) => {
        setBodegaSelected(nuevoValor);
        dispatch({ type: acciones.MODIFICAR_FILTROS_CONSULTA, payload: { llave: nombreValor, valor: nuevoValor ? nuevoValor.BodegaId : '' } });
    };

    return (
        <FormularioConsultaInventarioVista
            alAbrirDialogo={alAbrirDialogo}
            alLimpiarFiltros={alLimpiarFiltros}
            entidadesFiltro={{ bodegas, familias, clasificaciones, divisiones }}
            filtro={filtros}
            alCambiarValor={alCambiarfiltros}
            alCambiarValorAutocomplete={alCambiarValorAutocomplete}
            bodegaSelected={bodegaSelected}
        />
    );
};

const estadoAPropiedades = ({
    estadoAutenticacion: { usuarioInformacion },
}: IEstadoGlobal): IFormularioConsultaInventarioCVProps => ({ IdEmpresa: usuarioInformacion!.IdEmpresa });

export default connect<IFormularioConsultaInventarioCVProps, null, any, IEstadoGlobal>(
    estadoAPropiedades,
    null
)(FormularioConsultaInventarioCV);
